import axios from 'axios'

//The API host location
const apiHost = '64.227.16.239:1337'
const IS_LOCAL = false

export default {
  data() {
    return {
      categories: []
    }
  },
  getProjects() {

    var _p = 'http://' +
      apiHost +
      '/madsci-projects?_sort=sortOrder:DESC,date:DESC'

    //_p = "/madsci-projects-all.json"
    //console.log(_p)

    return axios
      .create({
        baseURL: _p,
        withCredentials: false,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .get()
  },
  getAdamLassyProjects() {

    var _p = IS_LOCAL ? '/json/Adam-Lassy-Projects.json' : 'http://' +
      apiHost +
      '/Adam-Lassy-Projects?_sort=sizeSquare:desc,year:desc'

    console.log(_p)

    return axios
      .create({
        baseURL: _p,
        withCredentials: false,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .get()
  },

  getApiHost() {
    return IS_LOCAL ? "" : "http://" + apiHost
  },

  created() {
    //console.log('>>> START STRAPI')
  }
}
